"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.string.sub.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.number.to-exponential.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/web.dom-collections.for-each.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _typeof2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/typeof.js"));

var _classCallCheck2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var _jsMd = require("js-md5");

var _pako = _interopRequireDefault(require("pako"));

var _bignumber = _interopRequireDefault(require("bignumber.js"));

var once = true;

var Socket = /*#__PURE__*/function () {
  function Socket(option) {
    (0, _classCallCheck2.default)(this, Socket);
    this.option = option;
    this.init();
  }

  (0, _createClass2.default)(Socket, [{
    key: "getInstance",
    value: function getInstance() {
      return this.socket;
    }
  }, {
    key: "sub",
    value: function sub(data) {
      var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // console.info("socket.readyState:", this.socket.readyState);
      // callback 返回的参数 1.正常 2.断线 3.ws链接异常
      if (!window.navigator.onLine) {
        option.callback && option.callback(2);
        return;
      }

      if (this.socket.readyState == this.socket.OPEN) {
        if ((0, _typeof2.default)(data) == "object") {
          this.socket.send(JSON.stringify(data));
        } else {
          this.socket.send(data);
        }

        option.callback && option.callback(1);
      } else {
        option.callback && option.callback(3);
      }
    }
  }, {
    key: "pingpong",
    value: function pingpong() {
      var _this = this;

      // console.log("this.socket.readyState:", this.socket.readyState);
      this.pingpongTimer = setInterval(function () {
        if (!window.navigator.onLine) {
          _this.option.offLineCallback && _this.option.offLineCallback();
        }

        if (_this.socket.readyState == 1) {
          _this.socket.sub("ping");
        } else {
          clearInterval(_this.pingpongTimer);
        }
      }, 6 * 1000);
    }
  }, {
    key: "init",
    value: function init() {
      once = true;
      var url = this.option.url;
      var link = "".concat(url);
      this.socket = new WebSocket(link);
      this.socket.onmessage = this.onmessage.bind(this);
      this.socket.onopen = this.onopen.bind(this);
      this.socket.onerror = this.onerror.bind(this);
      this.socket.onclose = this.onclose.bind(this);
      this.socket.sub = this.sub.bind(this);
    } // transferToNumber(inputNumber) {
    //   if (isNaN(inputNumber)) {
    //     return inputNumber;
    //   }
    //   inputNumber = "" + inputNumber;
    //   inputNumber = parseFloat(inputNumber);
    //   let eformat = inputNumber.toExponential(); // 转换为标准的科学计数法形式（字符串）
    //   let tmpArray = eformat.match(/\d(?:\.(\d*))?e([+-]\d+)/); // 分离出小数值和指数值
    //   let number = inputNumber.toFixed(
    //     Math.max(0, (tmpArray[1] || "").length - tmpArray[2])
    //   );
    //   return number;
    // }

  }, {
    key: "judgeWSType",
    value: function () {
      var _judgeWSType = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = null;
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  if (typeof res.data == "string") {
                    if (res.data == "pong") {
                      return resolve("--");
                    }

                    data = JSON.parse(res.data);
                    resolve(data);
                  } else {
                    var reader = new FileReader(); //创建文件类型

                    //创建文件类型
                    reader.readAsArrayBuffer(res.data); // 启动读取指定的 Blob 读取完成并触发 load 事件 （result是ArrayBuffer类型）

                    // 启动读取指定的 Blob 读取完成并触发 load 事件 （result是ArrayBuffer类型）
                    reader.onload = function () {
                      // 用第三方包解压
                      var txt = _pako.default.ungzip(this.result, {
                        to: "string"
                      });

                      if (txt == "pong") {
                        // 返回错误
                        return resolve("--");
                      }

                      data = JSON.parse(txt);

                      function transferToNumber(inputNumber) {
                        if (isNaN(inputNumber)) {
                          return inputNumber;
                        }

                        inputNumber = "" + inputNumber;
                        inputNumber = parseFloat(inputNumber);
                        var eformat = inputNumber.toExponential(); // 转换为标准的科学计数法形式（字符串）

                        // 转换为标准的科学计数法形式（字符串）
                        var tmpArray = eformat.match(/\d(?:\.(\d*))?e([+-]\d+)/); // 分离出小数值和指数值

                        // 分离出小数值和指数值
                        var number = inputNumber.toFixed(Math.max(0, (tmpArray[1] || "").length - tmpArray[2]));
                        return number;
                      }

                      if (data.data.data && data.data.field) {
                        //此处针对 ws2 =>ws3 数据格式转化
                        function formattedArrayData(data, name) {
                          //   console.log("name:", name, data);
                          var arr = [];
                          var copyArr = [];
                          var title = data.field.split(",");
                          data["data"].forEach(function (item, i) {
                            var line = item.split(",");
                            arr[i] = new Object();
                            arr[i]["currency"] = new Object();
                            title.forEach(function (m, n) {
                              arr[i][m] = transferToNumber(line[n]);
                              arr[i]["currency"][m] = transferToNumber(line[n]);
                            });
                          });
                          copyArr = arr;
                          return copyArr;
                        }

                        var bease = data;
                        bease.data = formattedArrayData(data.data, bease.action);
                        return resolve(bease);
                      }

                      resolve(data);
                    };

                    reader.onerror = function (e) {
                      reject(e);
                    };
                  }
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function judgeWSType(_x) {
        return _judgeWSType.apply(this, arguments);
      }

      return judgeWSType;
    }()
  }, {
    key: "onmessage",
    value: function () {
      var _onmessage = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.judgeWSType(res);

              case 2:
                data = _context2.sent;

                if (!(data == "--")) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                // console.log("-->--:", data);
                this.option.callback && this.option.callback(data);

                if (once) {
                  this.option.connectSuccessCallback && this.option.connectSuccessCallback(data);
                }

                once = false;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onmessage(_x2) {
        return _onmessage.apply(this, arguments);
      }

      return onmessage;
    }()
  }, {
    key: "onopen",
    value: function onopen() {
      this.option.mounted && this.option.mounted();
      this.socket.sub(this.option.subData);
      this.pingpong();
    }
  }, {
    key: "onerror",
    value: function onerror() {
      console.info("onerror");
      this.option.onConnect();
    }
  }, {
    key: "onclose",
    value: function onclose() {
      console.info("onclose");
      this.option.onConnect();
    }
  }]);
  return Socket;
}();

exports.default = Socket;